import { createBrowserRouter } from 'react-router-dom';

// routes
import PublicRoutes from './public-routes';

// ==============================|| ROUTING RENDER ||============================== //

const PublicAppRoutes = createBrowserRouter([PublicRoutes]);
export default PublicAppRoutes;
